export enum ECreditStatus {
  None = 'None',
  Empty = 'Empty',
  InProgress = 'InProgress',
  Activated = 'Activated',
  Failed = 'Failed',
  InClosure = 'InClosure',
  Closed = 'Closed',
}
